import { render, staticRenderFns } from "./synthesisCard.vue?vue&type=template&id=52736f8f&scoped=true&"
import script from "./synthesisCard.vue?vue&type=script&lang=js&"
export * from "./synthesisCard.vue?vue&type=script&lang=js&"
import style0 from "./synthesisCard.vue?vue&type=style&index=0&id=52736f8f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52736f8f",
  null
  
)

export default component.exports